import React from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';
import { t } from '@/i18n/translations';

const Footer = () => {
  const { lang } = useLanguage();
  const nav = t('nav', lang);
  const ft = t('footer', lang);

  const navLinks = [
    { name: nav.home, path: '/' },
    { name: nav.chiSiamo, path: '/chi-siamo' },
    { name: nav.cosaOffriamo, path: '/cosa-offriamo' },
    { name: nav.comeFunziona, path: '/come-funziona' },
    { name: nav.proprietario, path: '/sei-un-proprietario' },
    { name: nav.strutture, path: '/strutture' },
  ];

  return (
    <footer className="bg-[#3e716c] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <img 
              src="/logo_footer.jpg" 
              alt="Homewise" 
              className="h-24 w-auto mb-4"
            />
            <p className="text-sm text-white/70 mt-2">
              Homewise Sagl<br />
              Via al Gaggio 15B, 6912 Pazzallo
            </p>
          </div>

          <div>
            <h3 className="font-semibold mb-4" style={{fontFamily: "'Cabinet Grotesk', sans-serif"}}>{ft.nav}</h3>
            <ul className="space-y-2">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-white/70 hover:text-white transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4" style={{fontFamily: "'Cabinet Grotesk', sans-serif"}}>{ft.contacts}</h3>
            <ul className="space-y-2">
              <li className="flex items-center space-x-2 text-sm text-white/70">
                <Mail size={16} />
                <a href="mailto:info@home-wise.ch" className="hover:text-white transition-colors">
                  info@home-wise.ch
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 mt-8 pt-8 text-center text-sm text-white/60">
          <p>&copy; {new Date().getFullYear()} Homewise Sagl. {ft.rights}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;